import React, { useState, useEffect } from 'react';
import { updateAuthUser } from '../../actions/auth';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert } from '../../services/notiflix.service';
import ProjectsService from '../../services/projects.service';
import ProjectCard from '../../components/layouts/ProjectCard';
import DashboardService from '../../services/dashboard.service';
import VerificationFailed from '../../components/common/VerificationFailed';
import EsignaturePop from '../../components/common/EsignaturesPop';
import OwnedAssetService from '../../services/owned-asset.service';
import 'react-loading-skeleton/dist/skeleton.css';
import CompleteProfileModal from '../../components/common/profile/CompleteProfileModal';
import InvestmentSummaryCard from '../../components/dashboard/InvestmentSummaryCard';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import KycTermsCondition from '../../components/common/KycTermsCondition';
import {
  RightSign,
  ClockRunningIcon,
  CrossSignIcon,
  EnergyBarTopSvgIcon,
} from '../../components/common/IconProvider';
import {
  calculateEnergyCapacity,
  DynamicEnergyBarDownIcon,
  DynamicEnergyBarTopSvgIcon,
  formatNumber,
  formatWithEllipsis,
} from '../../utils/Helper';
import ImageLoader from '../../components/common/ImageLoader';
import ProjectListingRootComponent from '../../components/common/projectListing/ProjectListingRootComponent';
import { useTranslation } from 'react-i18next';
import { OnchainTransactionHistory } from '../projects/ProjectDetails';
import TransactionService from '../../services/transaction.service';
import KycVerification from '../../components/KycVerification';
import configService from '../../services/config.service';
const Dashboard = () => {
  const dispatch = useDispatch();
  const { user: _authUser } = useSelector((state) => state.auth);
  const { wallet } = useSelector((state) => state.wallet);
  const [projectLoading, setProjectLoading] = useState(false);
  const [ownedAssetLists, setOwnedAssetList] = useState([]);
  const [ownedAssetCart, setOwnedAssetCart] = useState(null);
  const [ownedAssetCartArray, setOwnedAssetCartArray] = useState(null);
  const [onChainTransactionLists, setOnChainTransactionList] = useState([]);
  const [onchainListLoading, setOnchainListLoading] = useState(false);
  const [filterOnChainData, setFilterOnChainData] = useState({
    perPage: 5,
    page: 1,
    commonSearch: '',
    sortBy: '',
    project_id: '',
    type: '',
    includeAll: true,
  });
  const [isPagination, setPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });
  const [userProfile, setUserProfile] = useState(null);
  const [, setIsOpenAggrement] = useState(null);
  const [isView, setView] = useState(1);
  const [selectedOption, selectOptions] = useState('new_to_old');
  const [filterData, setFilterData] = useState({
    perPage: 7,
    page: 1,
    commonSearch: '',
    sortBy: 'new_to_old',
    investmentType: '',
  });
  const [filterOwnedAssetData] = useState({
    perPage: 20,
    page: 1,
    commonSearch: '',
    sortBy: '',
    user_id: _authUser?.userId || '',
  });
  const [projectLists, setProjectList] = useState([]);
  const [isDashboardData, setDashboardData] = useState(null);
  const [kycFailedReasons, setKycFailedReasons] = useState([]);
  const [lagerTotalQuantity, setLagerTotalQuantity] = useState(0);
  const [isDashboardLoading, setDashboardLoading] = useState(false);
  const [showPlatformAgreement, setPlatformAgreement] = useState(false);
  const [isSortingLoader, setSortingLoader] = useState(false);
  const [isDropDownList, setIsDropDownList] = useState([]);
  const [isProjectPagination, setProjectPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });
  const [isKycConsent, setKycConsent] = useState(false);
  const [showCompleteProfileModal, setShowCompleteProfileModal] =
    useState(false);
  const [showModalKYC, setShowModalKYC] = useState(false);
  const [showModalVerificationStatus, setShowModalVerificationStatus] =
    useState(false);
  useEffect(() => {
    ownedAssetList();
    projectsList();
  }, [filterData]);

  const { t } = useTranslation(['dashboard', 'common', 'projectList']);
  useEffect(() => {}, [t]);
  useEffect(() => {
    setIsDropDownList([
      {
        name: t('projectList:new_to_old'),
        value: 'new_to_old',
      },
      {
        name: t('projectList:old_to_new'),
        value: 'old_to_new',
      },
      {
        name: t('projectList:low_to_high_cost'),
        value: 'low_to_high',
      },
      {
        name: t('projectList:high_to_low_cost'),
        value: 'high_to_low',
      },
    ]);
  }, [t]);

  const projectsList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
    isSorting = false,
  ) => {
    try {
      if (isSorting) {
        setSortingLoader(true); // Show sorting loader
      } else {
        setProjectLoading(true); // Show pagination loader
      }
      const { currentPage } = pagination;
      const { field, order } = sorting;
      let projectListRes = await ProjectsService.list(
        filterData.perPage,
        currentPage,
        filterData.commonSearch,
        filterData.sortBy,
        filterData.investmentType,
        field,
        order,
        true,
      );
      if (projectListRes.status === 'failure') {
        setProjectLoading(false);
        setSortingLoader(false);
        Alert.error(projectListRes.message);
        return false;
      }
      setProjectLoading(false);
      setSortingLoader(false);
      setProjectList(projectListRes.data.records);
      setProjectPagination({
        totalPages: projectListRes.data.pagination.totalPages,
        currentPage: projectListRes.data.pagination.page,
      });
    } catch (error) {
      setProjectLoading(false);
      setSortingLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  const dashboardData = async () => {
    try {
      setDashboardLoading(true);
      let dashboardRes = await DashboardService.getDashboardData();
      if (dashboardRes.status === 'failure') {
        setDashboardLoading(false);
        Alert.error(dashboardRes.message);
        return false;
      }

      if (
        dashboardRes?.data?.userData?.kycReports &&
        dashboardRes?.data?.userData?.kycReports?.length > 0
      ) {
        const rawReasons = dashboardRes?.data?.userData?.kycReports[0].reasons;

        try {
          const moderationComment = rawReasons?.moderationComment
            ? rawReasons?.moderationComment
            : rawReasons?.rejectLabels;

          const reasons = rawReasons?.moderationComment
            ? moderationComment
                .split('\n')
                .filter((line) => line.trim() !== '') // remove empty lines
                .slice(0, 3)
            : moderationComment; // get first 3

          setKycFailedReasons(reasons);
        } catch (error) {
          Alert.error(error.message);
          setKycFailedReasons([]);
        }
      }
      setDashboardData(dashboardRes.data);
      let data = formatWithEllipsis(
        dashboardRes.data?.userData?.userBankDetail?.account_no,
        4,
        null,
      );
      let authUser = { ..._authUser };
      authUser['bank_details'] = data ? true : false;
      authUser['kyc_status'] = dashboardRes.data?.userData?.kyc_status;
      authUser['userName'] = dashboardRes.data?.userData?.full_name;
      authUser['platform_agreement_status'] =
        dashboardRes.data?.userData?.agreements?.length > 0
          ? dashboardRes.data?.userData?.agreements[0]?.agreement_status
          : 0;
      await Promise.resolve(dispatch(updateAuthUser(authUser)));
      setDashboardLoading(false);
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  const ownedAssetList = async () => {
    try {
      let ownedAssetListRes = await OwnedAssetService.list(
        filterOwnedAssetData.perPage,
        filterOwnedAssetData.page,
        filterOwnedAssetData.commonSearch,
        filterOwnedAssetData.sortBy,
        filterOwnedAssetData.user_id,
      );
      if (ownedAssetListRes.status === 'failure') {
        setDashboardLoading(false);
        Alert.error(ownedAssetListRes.message);
        return false;
      }
      let largest = [];
      setOwnedAssetList(ownedAssetListRes?.data?.records);
      for (const iterator of ownedAssetListRes?.data?.records ?? []) {
        largest.push(iterator.total_quantity);
      }
      setLagerTotalQuantity(largest ? Math.max(...largest) : 0);
    } catch (error) {
      setDashboardLoading(false);
      Alert.error(error.message);
      return false;
    }
  };
  const modelClose = async () => {
    setShowModalKYC(false);
    setPlatformAgreement(false);
    await dashboardData();
  };

  const closeCompleteProfileModal = async () => {
    await dashboardData();
    setShowCompleteProfileModal(false);
  };

  const docsignPopOpen = async () => {
    setShowModalKYC(false);
    if (
      isDashboardData?.userData?.agreements &&
      isDashboardData?.userData?.agreements[0]?.agreement_status !== 1
    ) {
      setPlatformAgreement(true);
    }
    await dashboardData();
  };
  const kycRejectPop = () => {
    if (isDashboardData.totalKycAttempt >= 2) {
      return false;
    }
    setShowModalVerificationStatus(false);

    setShowModalKYC(true);
  };

  useEffect(() => {
    dashboardData();
  }, [wallet]);

  const KYCModelOpen = () => {
    if (isDashboardData.totalKycAttempt >= 2) {
      Alert.error(t('common:kyc_attempt_reached'));
      return false;
    }
    setKycConsent(true);
  };
  const declineModelClose = async () => {
    await dashboardData();
    setShowModalKYC(false);
    setPlatformAgreement(false);
  };

  const ownAssetCart = async (project_index) => {
    let data = ownedAssetLists.at(project_index);

    let rowData = [];
    rowData.push(data);
    setOwnedAssetCart(data);
    setOwnedAssetCartArray(rowData);
    return false;
  };

  /* Hide project card, if user click on outside */
  if (isDashboardData && isDashboardData?.totalUsersInvestment > 0) {
    const parentBody = document.getElementsByClassName('parentBody')[0];
    parentBody.addEventListener('click', () => {
      setOwnedAssetCart(null);
    });
  }

  const onChainTransactionList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
  ) => {
    try {
      const { currentPage } = pagination;
      const { field, order } = sorting;
      let projectListRes = await TransactionService.onChainList(
        filterOnChainData.perPage,
        currentPage,
        filterOnChainData.commonSearch,
        filterOnChainData.sortBy,
        filterOnChainData.project_id,
        filterOnChainData.type,
        field,
        order,
        filterOnChainData.includeAll,
      );
      if (projectListRes.status === 'failure') {
        setOnchainListLoading(false);
        Alert.error(projectListRes.message);
        return false;
      }
      setOnchainListLoading(false);
      setOnChainTransactionList(projectListRes.data.records);
      setPagination({
        totalPages: projectListRes.data.pagination.totalPages,
        currentPage: projectListRes.data.pagination.page,
      });
    } catch (error) {
      setOnchainListLoading(false);
      Alert.error(error.message);
      return false;
    }
  };

  const searchData = async (_action, _value) => {
    if (_action === 'investmentType' && _value === filterData.investmentType)
      return false;
    selectOptions(_value);
    setFilterData({
      ...filterData,
      page: 1,
      [_action]: _value,
    });
  };

  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });
    setFilterOnChainData({
      ...filterOnChainData,
      page: current,
    });
  };

  useEffect(() => {
    onChainTransactionList();
  }, [filterOnChainData]);

  return (
    <>
      <div className="parentBody">
        <div>
          <div className="md:pl-5 pb-5 w-full max-w-full overflow-x-hidden">
            <WelcomeSection isDashboardData={isDashboardData} />
            <ProjectDetailsSection
              isDashboardLoading={isDashboardLoading}
              isDashboardData={isDashboardData}
              ownedAssetLists={ownedAssetLists}
              ownedAssetCart={ownedAssetCart}
              ownedAssetCartArray={ownedAssetCartArray}
              ownAssetCart={ownAssetCart}
              lagerTotalQuantity={lagerTotalQuantity}
              _authUser={_authUser}
            />

            {isDashboardData?.userData?.kyc_status === 1 &&
            isDashboardData?.userData?.userBankDetail != null &&
            isDashboardData?.userData?.agreements?.length > 0 &&
            isDashboardData?.userData?.agreements[0].agreement_status === 1
              ? ''
              : isDashboardLoading === false && (
                  <NewUserOnboardProcess
                    userProfile={userProfile}
                    isDashboardData={isDashboardData}
                    setShowCompleteProfileModal={setShowCompleteProfileModal}
                    KYCModelOpen={KYCModelOpen}
                    docsignPopOpen={docsignPopOpen}
                    setShowModalKYC={setShowModalKYC}
                    setShowModalVerificationStatus={
                      setShowModalVerificationStatus
                    }
                  />
                )}
            <ProjectListingRootComponent
              headerText={t('common:available_projects')}
              projectLists={projectLists}
              message={t('common:no_data_found')}
              slug={'dashboard'}
              projectLoading={projectLoading}
              count={8}
              isView={isView}
              setView={setView}
              isSortingLoader={isSortingLoader}
              list={projectsList}
              searchData={searchData}
              value={selectedOption}
              isDropDownList={isDropDownList}
              isPagination={isProjectPagination}
              setPagination={setProjectPagination}
              isListLoader={projectLoading}
              filterData={filterData}
            />

            <OnchainTransactionHistory
              onChainTransactionLists={onChainTransactionLists}
              isPagination={isPagination}
              filterData={filterOnChainData}
              isListLoader={onchainListLoading}
              list={onChainTransactionList}
              setPagination={setPagination}
              handlePagination={handlePagination}
              slug={'dashboard'}
            />
          </div>
        </div>
        {showCompleteProfileModal ? (
          <CompleteProfileModal
            modelClose={closeCompleteProfileModal}
            setUserProfile={setUserProfile}
            userProfile={userProfile}
          />
        ) : null}

        {showModalKYC ? <KycVerification modelClose={modelClose} /> : null}
        {isKycConsent && (
          <KycTermsCondition
            modelClose={setKycConsent}
            setKycModal={setShowModalKYC}
          />
        )}

        {showModalVerificationStatus ? (
          <VerificationFailed
            kycStatus={isDashboardData?.userData?.kyc_status}
            kycRejectPop={kycRejectPop}
            kycLimit={isDashboardData?.totalKycAttempt}
            reasons={kycFailedReasons}
            setShowModalVerificationStatus={setShowModalVerificationStatus}
          />
        ) : null}
      </div>
      {showPlatformAgreement ? (
        <EsignaturePop
          declineModelClose={declineModelClose}
          type={'platform'}
          modelClose={modelClose}
          setIsOpenAggrement={setIsOpenAggrement}
        />
      ) : null}
    </>
  );
};

export const WelcomeSection = ({ isDashboardData }) => {
  const { user: _authUser } = useSelector((state) => state.auth);
  const { t } = useTranslation(['dashboard', 'common']);
  const stepsCompleted =
    isDashboardData?.userData?.kyc_status === 1 &&
    isDashboardData?.userData?.userBankDetail != null &&
    _authUser?.platform_agreement_status === 1;
  return (
    <>
      {isDashboardData && isDashboardData?.totalUsersInvestment === 0 && (
        <div className="text-center md:mt-20 mt-10 dark:text-white">
          <h1 className="md:text-6xl text-3xl font-medium mb-6">
            {t('common:welcome_message', {
              appName: configService.appName(),
            })}
            <br />
            <span className="block mt-3">{_authUser?.userName || ' '}</span>
          </h1>
          <p className="md:text-xl text-base font-semibold max-w-lg mx-auto">
            {stepsCompleted
              ? t('start_investing_message')
              : t('start_investing_steps')}
          </p>
          <div className=" h-[300px] flex flex-col justify-end items-center">
            <Link to="/assets">
              <div>
                <div className="text-center">
                  <ImageLoader
                    src="/img/purchasenew.png"
                    className="mx-auto"
                    alt=""
                  />
                </div>
                <div className="text-[#85919F] font-semibold mt-7 text-center">
                  {t('common:purchase_new')}
                </div>
              </div>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export const ProjectDetailsSection = ({
  isDashboardLoading,
  isDashboardData,
  ownedAssetLists,
  ownedAssetCart,
  ownedAssetCartArray,
  ownAssetCart,
  lagerTotalQuantity,
  _authUser,
}) => {
  const { t } = useTranslation(['dashboard', 'common']);
  return (
    <div>
      {isDashboardLoading && (
        <div className="grid gap-5 md:grid-cols-12 ">
          <div className={'col-span-12 lg:col-span-12 xl:col-span-12'}>
            <h2 className="dark:text-white">
              {t('welcome_back')} {_authUser?.userName || ' '}
            </h2>
            <p className="font-semibold mb-3 text-base dark:text-white">
              {t('start_investing_projects')}
            </p>
            <div className="flex py-5 gap-x-4 items-end overflow-x-auto justify-center">
              <div className="dashboard-full-width-center">
                <div className="fixed-dimensions">
                  <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
                    <div className="p-4  bg-gray-50 rounded-xl">
                      <Skeleton count={1} height={80} className="" />
                    </div>
                  </SkeletonTheme>
                </div>
              </div>
              <div className="dashboard-full-width-center">
                <div className="fixed-dimensions">
                  <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
                    <div className="p-4  bg-gray-50 rounded-xl">
                      <Skeleton count={1} height={230} className="" />
                    </div>
                  </SkeletonTheme>
                </div>
              </div>
              <div className="dashboard-full-width-center">
                <div className="fixed-dimensions">
                  <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
                    <div className="p-4  bg-gray-50 rounded-xl">
                      <Skeleton count={1} height={120} className="" />
                    </div>
                  </SkeletonTheme>
                </div>
              </div>
              <div className="dashboard-full-width-center">
                <div className="fixed-dimensions">
                  <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
                    <div className="p-4  bg-gray-50 rounded-xl">
                      <Skeleton count={1} height={50} className="" />
                    </div>
                  </SkeletonTheme>
                </div>
              </div>
              <div className="dashboard-full-width-center">
                <div className="fixed-dimensions">
                  <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
                    <div className="p-4  bg-gray-50 rounded-xl">
                      <Skeleton count={1} height={180} className="" />
                    </div>
                  </SkeletonTheme>
                </div>
              </div>
              <Link to={'/assets'}>
                <div className="dashboard-full-width-center">
                  <div className="fixed-dimensions">
                    <p className="font-normal text-gray-500 text-sm mb-4">
                      &nbsp;
                    </p>
                    <div className="flex-column-end-center">
                      <EnergyBarTopSvgIcon />
                    </div>
                  </div>
                  <p className="font-semibold text-gray-500 text-sm mt-4">
                    {t('common:purchase_new')}
                  </p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      )}
      {isDashboardData && isDashboardData?.totalUsersInvestment > 0 && (
        <>
          <div className="md:grid md:gap-5 md:grid-cols-12 ">
            <div
              className={
                ownedAssetCart
                  ? 'col-span-12 lg:col-span-8 xl:col-span-9'
                  : 'col-span-12 lg:col-span-12 xl:col-span-12'
              }
            >
              <h2 className="dark:text-white">
                {t('welcome_back')} {_authUser?.userName || ' '}
              </h2>
              <p className="font-semibold mb-3 text-base dark:text-white">
                {t('start_investing_projects')}
              </p>

              <div className="min-h-[400px] max-h-full flex flex-col justify-end">
                <DashboardOwnedProjectsGraphList
                  ownedAssetLists={ownedAssetLists}
                  lagerTotalQuantity={lagerTotalQuantity}
                  ownedAssetCart={ownedAssetCart}
                  ownAssetCart={ownAssetCart}
                />
              </div>
            </div>
            {ownedAssetCart && (
              <div className="col-span-12 lg:col-span-4 xl:col-span-3 custm-height">
                <ProjectCard
                  projectLists={ownedAssetCartArray}
                  slug={'owned-assets'}
                />
              </div>
            )}
          </div>

          <div>
            <div className="grid gap-5 md:grid-cols-2 mt-6">
              <InvestmentSummaryCard
                title={t('total_holdings')}
                amount={isDashboardData?.totalInvestment}
                graphData={isDashboardData?.projectType}
                totalAmount={isDashboardData?.totalInvestment || '0'}
              />
              <InvestmentSummaryCard
                title={t('payout_received')}
                amount={isDashboardData?.total_payout_amount}
                graphData={isDashboardData?.project_payout}
                totalAmount={isDashboardData?.total_payout_amount || '0'}
                noDataMessage={t('not_recieved_payout')}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export const DashboardOwnedProjectsGraphList = ({
  ownedAssetLists,
  lagerTotalQuantity,
  ownedAssetCart,
  ownAssetCart,
}) => {
  const { t } = useTranslation(['dashboard', 'common']);
  return (
    <div className="overflow-x-auto py-5 pl-4">
      <div className="flex justify-center gap-x-4 items-end min-w-max">
        {ownedAssetLists &&
          ownedAssetLists?.length > 0 &&
          ownedAssetLists.map((list, index) => {
            let height = (list?.total_quantity / lagerTotalQuantity) * 230;

            return (
              <div
                key={index}
                onClick={() => ownAssetCart(index)}
                className="text-center"
              >
                <div
                  className={`p-2 border-dotted rounded-2xl border
                  ${
                    ownedAssetCart &&
                    ownedAssetCart?.project_id === list?.project_id
                      ? 'border-gray-400'
                      : 'border-transparent hover:border-gray-400 cursor-pointer'
                  }`}
                >
                  <div className="fixed-dimensions">
                    {list?.projectDetail?.investment_type === 'bond' ? (
                      <p className="font-normal text-sm text-brandBlue dark:text-gray-100 mb-4">
                        {formatNumber(list?.total_invested_amount)}
                      </p>
                    ) : (
                      <p className="font-normal text-sm text-brandBlue dark:text-gray-100 mb-4">
                        {formatNumber(
                          calculateEnergyCapacity(
                            list?.projectDetail?.energy_capacity,
                            list?.projectDetail?.available_for_sale,
                            list?.quantity,
                          ),
                          { style: 'decimal' },
                        )}{' '}
                        kW
                      </p>
                    )}

                    <div className="flex-column-end-center">
                      <DynamicEnergyBarTopSvgIcon
                        slug={list?.projectDetail?.projectsType?.slug}
                      />
                      <div
                        className={
                          'w-full bg-[#' +
                          list?.projectDetail?.projectsType?.color_code +
                          '] -mt-[38px] z-[1]'
                        }
                        style={{ height: +height + 'px' }}
                      ></div>
                      <DynamicEnergyBarDownIcon
                        slug={list?.projectDetail?.projectsType?.slug}
                      />
                    </div>

                    <p className="font-semibold text-brandBlue text-sm dark:text-gray-100 mt-4 truncate">
                      {list?.projectDetail?.name || 'NA'}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}

        <div className="p-4">
          <Link to={'/assets'} className="dashboard-full-width-center">
            <div className="fixed-dimensions">
              <p className="font-normal text-gray-500 text-sm mb-4">&nbsp;</p>
              <div className="flex-column-end-center">
                <EnergyBarTopSvgIcon />
              </div>
            </div>
            <p className="font-semibold text-gray-500 text-sm mt-4">
              {t('common:purchase_new')}
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const NewUserOnboardProcess = ({
  userProfile,
  isDashboardData,
  setShowCompleteProfileModal,
  KYCModelOpen,
  docsignPopOpen,
  setShowModalVerificationStatus,
}) => {
  const { t } = useTranslation(['dashboard', 'common']);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8 xl:mt-10">
      <div className="bg-[#ECECEC] dark:bg-slate-800 dark:text-slate-200 p-5 md:p-7 rounded-2xl md:h-auto flex flex-col justify-between text-left">
        <div className="mb-3 md:mb-0">
          <h3 className="pb-2 mb-4 border-b border-[#B6BDC5]">
            {t('review_profile')}
          </h3>
          <p className="text-md md:text-lg text-[#85919F] dark:text-slate-400 mb-6">
            {t('complete_your_profile')}
          </p>
        </div>
        <div className="text-left">
          {userProfile?.userBankDetail ||
          isDashboardData?.userData?.userBankDetail != null ? (
            <div className="text-green-700 border border-green-700 py-2 px-3 rounded w-auto inline-flex items-center">
              <RightSign />
              <p className="flex text-md font-semibold items-center">
                {t('common:completed')}
              </p>
            </div>
          ) : (
            <button
              className="bg-brandOrange text-brandBlue text-md leading-normal py-2 px-5 rounded w-auto inline-flex items-center font-semibold"
              onClick={() => setShowCompleteProfileModal(true)}
            >
              {t('complete_profile')}
            </button>
          )}
        </div>
      </div>
      <div className="bg-[#ECECEC] dark:bg-slate-800 dark:text-slate-200 p-5 md:p-7 rounded-2xl md:h-auto flex flex-col justify-between text-left">
        <div className="mb-3 md:mb-0">
          <h3 className="pb-2 mb-4 border-b border-[#B6BDC5]">
            {t('common:complete_kyc')}
          </h3>
          <p className="text-md md:text-lg text-[#85919F] dark:text-slate-400 mb-8">
            {t('kyc_msg')}
          </p>
        </div>
        {isDashboardData && isDashboardData?.userData?.kyc_status === 0 ? (
          <div className="text-left">
            <button
              onClick={() => KYCModelOpen()}
              className="bg-[#A7D760] text-[#0B243F] kyc text-md font-semibold rounded-md px-5 leading-normal py-2 flex flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all"
              disabled={isDashboardData?.userData?.userBankDetail === null}
            >
              {t('common:proceed_to_kyc')}
            </button>
          </div>
        ) : isDashboardData?.userData?.kyc_status === 1 ? (
          <div className="text-left">
            <div className="text-green-700 border border-green-700 py-2 px-3 rounded w-auto inline-flex items-center">
              {' '}
              <RightSign />
              <p className="leading-tight text-md font-semibold">
                {' '}
                {t('common:kyc_completed')}
              </p>
            </div>
          </div>
        ) : isDashboardData?.userData?.kyc_status === 3 ? (
          <div className="text-left flex items-center justify-between">
            <div className="border-brandOrange border text-brandOrange py-2 px-2 rounded w-auto inline-flex items-center">
              <ClockRunningIcon />
              <p className="leading-tight text-md font-semibold">
                {t('common:kyc_initaited')}
              </p>
            </div>

            <div
              className="text-blue-800 dark:text-GreenColor cursor-pointer font-bold pb-1 border-b border-blue-600 dark:border-GreenColor inline-flex items-center"
              onClick={() => KYCModelOpen()}
            >
              <p className="leading-tight">{t('common:continue')}</p>
            </div>
          </div>
        ) : (
          <></>
        )}
        {isDashboardData &&
          (isDashboardData?.userData?.kyc_status === 2 ||
            isDashboardData?.userData?.kyc_status === 4) && (
            <div className="text-left flex items-center justify-between">
              <div
                className={`border  ${
                  isDashboardData?.userData?.kyc_status === 2
                    ? 'border-brandRed text-brandRed'
                    : 'border-brandOrange  text-brandOrange '
                } py-2 px-5 rounded w-auto inline-flex items-center`}
              >
                {' '}
                {isDashboardData?.userData?.kyc_status === 2 ? (
                  <CrossSignIcon />
                ) : (
                  <ClockRunningIcon _bold={true} />
                )}
                <p className="leading-tight text-md font-semibold">
                  {isDashboardData?.userData?.kyc_status === 2
                    ? t('common:kyc_failed')
                    : t('common:in_review')}
                </p>
              </div>

              <div
                className="text-blue-600 dark:text-GreenColor cursor-pointer font-bold pb-1 border-b border-blue-600 dark:border-GreenColor inline-flex items-center"
                onClick={() => setShowModalVerificationStatus(true)}
              >
                <p className="leading-tight">{t('common:check_the_queries')}</p>
              </div>
            </div>
          )}
      </div>
      <div className="bg-[#ECECEC] dark:bg-slate-800 dark:text-slate-200 p-5 md:p-7 rounded-2xl md:h-auto flex flex-col justify-between text-left">
        <div className="mb-3 md:mb-0">
          <h3 className="pb-2 mb-4 border-b border-[#B6BDC5]">
            {t('sign_agreement')}
          </h3>
          <p className="text-md md:text-lg text-[#85919F] dark:text-slate-400 mb-6">
            {t('our_terms_of_service')}
          </p>
        </div>
        {isDashboardData &&
        (isDashboardData?.userData?.agreements?.length === 0 ||
          isDashboardData?.userData?.agreements[0]?.agreement_status === 0) ? (
          <div className="text-left">
            <button
              onClick={() => docsignPopOpen()}
              disabled={isDashboardData?.userData?.kyc_status !== 1}
              className="bg-[#A7D760] text-[#0B243F] kyc text-md font-semibold rounded-md px-5 leading-normal py-2 flex flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all"
            >
              {t('common:sign')}
            </button>
          </div>
        ) : isDashboardData?.userData?.agreements[0]?.agreement_status === 1 ? (
          <div className="text-left">
            <div className="text-green-700 border border-green-700 py-2 px-3 rounded w-auto inline-flex items-center">
              <RightSign />
              <p className="leading-normal text-md font-semibold flex items-center">
                {t('agreement_signed')}
              </p>
            </div>
          </div>
        ) : (
          isDashboardData?.userData?.agreements[0]?.agreement_status === 2 && (
            <div className="text-left flex items-center justify-between">
              <div
                className={
                  'border-brandRed text-brandRed py-2 px-5 rounded w-auto inline-flex items-center'
                }
              >
                <CrossSignIcon />

                <p className="leading-tight text-md font-semibold">
                  {t('agreement_declined')}
                </p>
              </div>

              <button
                onClick={() => docsignPopOpen()}
                disabled={isDashboardData?.userData?.kyc_status === 0}
                className="bg-[#A7D760] text-[#0B243F] kyc text-md font-semibold rounded-md px-5 leading-normal py-2 flex flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all"
              >
                {t('common:sign')}
              </button>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Dashboard;
